import { SubscriptionFeature } from "../../../types/billing/SubscriptionFeature";

export const dataEntryFeatures: SubscriptionFeature[] = [
    SubscriptionFeature.IssuanceMonitorFullAccess
]